((g) => {
  var h,
    a,
    k,
    p = 'The Google Maps JavaScript API',
    c = 'google',
    l = 'importLibrary',
    q = '__ib__',
    m = document,
    b = window;
  b = b[c] || (b[c] = {});
  var d = b.maps || (b.maps = {}),
    r = new Set(),
    e = new URLSearchParams(),
    u = () =>
      h ||
      (h = new Promise(async (f, n) => {
        await (a = m.createElement('script'));
        e.set('libraries', [...r] + '');
        for (k in g)
          e.set(
            k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
            g[k]
          );
        e.set('callback', c + '.maps.' + q);
        a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
        d[q] = f;
        a.onerror = () => (h = n(Error(p + ' could not load.')));
        a.nonce = m.querySelector('script[nonce]')?.nonce || '';
        m.head.append(a);
      }));
  d[l]
    ? console.warn(p + ' only loads once. Ignoring:', g)
    : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
})({
  key: 'AIzaSyB0WkoZvq7lQqMTswgpUs3E5V7hrBUGYyQ',
  v: 'weekly',
  // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
  // Add other bootstrap parameters as needed, using camel case.
});

console.log('here are locations: ', LOCATIONS);

// Initialize and add the map
let map;
async function initMap() {
  // Request needed libraries.
  //@ts-ignore

  const { Map } = await google.maps.importLibrary('maps');
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    'marker'
  );

  // The location of Lola's 214
  const position = { lat: 51.535118, lng: -0.25802 };

  // The map, centered at Lola's
  map = new Map(document.getElementById('map'), {
    zoom: 14,
    ...(!localStorage.getItem('postcode')
      ? {
          center: position,
        }
      : {}),
    mapId: '8baa37ecb09f28d13ccad855',
    mapTypeControl: false,
  });

  // * styled pin

  for (let locker of LOCATIONS.lockers) {
    const pin = new PinElement({
      borderColor: '#E04F85',
      background: '#FFD2E9',
      glyphColor: '#E04F85',
    });
    new AdvancedMarkerElement({
      map: map,
      position: {
        lat: parseFloat(locker.lat),
        lng: parseFloat(locker.lng),
      },
      title: locker.name,
      content: pin.element,
    });
  }
  for (let store of LOCATIONS.stores) {
    const pin = new PinElement({
      borderColor: '#E04F85',
      background: '#FFD2E9',
      glyphColor: '#E04F85',
    });
    new AdvancedMarkerElement({
      map: map,
      position: {
        lat: parseFloat(store.lat),
        lng: parseFloat(store.lng),
      },
      title: store.name,
      content: pin.element,
    });
  }

  // * listen for changes to lat/long inputs

  const latInput = document.querySelector("input[name='current_lat']");
  const lngInput = document.querySelector("input[name='current_lng']");

  const addrPinStyle = new PinElement({
    borderColor: '#0062A6',
    background: '#EBF6FF',
    glyphColor: '#0062A6',
  });

  const addrPin = new AdvancedMarkerElement({
    map: map,
    content: addrPinStyle.element,
  });

  google.maps.event.addDomListener(lngInput, 'change', (e) => {
    const nPos = {
      lat: parseFloat(latInput.value),
      lng: parseFloat(lngInput.value),
    };

    console.log('new lat/lng - changing POSITION');

    const savedPostcode = localStorage.getItem('postcode');

    addrPin.position = nPos;
    addrPin.title = savedPostcode.toUpperCase();

    map.setCenter(nPos);
  });

  //   const marker = new AdvancedMarkerElement({
  //     map: map,
  //     position: position,
  //     title: `Lola's`,
  //     content: pin.element
  //   });
}

initMap();
